module.exports = "<i class=\"fontello-icons icon-droplet change-object-color\"\r\n   [class.active]=\"isActive\"\r\n   [cpOKButton]=\"true\"\r\n   [cpOKButtonText]=\"'Apply'\"\r\n   [(colorPicker)]=\"color\"\r\n   [cpOutputFormat]=\"'hex'\"\r\n   (colorPickerChange)=\"colorChange($event)\"\r\n   [cpPosition]=\"'bottom'\"></i>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/proTools/ng-components/change-object-color/change-object-color.component.html
// module id = ./src/app/services/proTools/ng-components/change-object-color/change-object-color.component.html
// module chunks = main